export const supportV2OrderAction = [
  "editOrder",
  "cancelOrder",
  "createReturn",
  "createClaim",
  "duplicateOrder",
  "refundOrder",
  "viewInRedo",
] as const;

export type SupportV2OrderAction = (typeof supportV2OrderAction)[number];

interface OrderActionEligibilityOrder {
  shopify?: {
    fulfillment_status?: string | null;
    fulfillments?: unknown[] | null;
    closed_at?: string | null;
    cancelled_at?: string | null;
  };
}

export function getAvailableSupportV2OrderActions({
  order,
  returnsEnabled,
  packageProtectionEnabled,
  canViewAllOrders,
  canEditOrder,
  canEditReturn,
}: {
  order: OrderActionEligibilityOrder;
  returnsEnabled: boolean | undefined;
  packageProtectionEnabled: boolean | undefined;
  canViewAllOrders: boolean;
  canEditOrder: boolean;
  canEditReturn: boolean;
}): SupportV2OrderAction[] {
  const unfulfilled =
    (!order.shopify?.fulfillment_status ||
      order.shopify.fulfillment_status.toLowerCase() === "unfulfilled") &&
    order.shopify?.fulfillments?.length === 0;
  const closed = order.shopify?.closed_at !== null;
  const cancelled = order.shopify?.cancelled_at !== null;

  const availableActions: SupportV2OrderAction[] = [];

  if (unfulfilled && !closed && !cancelled && canEditOrder) {
    availableActions.push("editOrder");
  }
  if (unfulfilled && !closed && !cancelled && canEditOrder) {
    availableActions.push("cancelOrder");
  }
  if (!unfulfilled && !cancelled && returnsEnabled && canEditReturn) {
    availableActions.push("createReturn");
  }
  if (!unfulfilled && !cancelled && packageProtectionEnabled && canEditReturn) {
    availableActions.push("createClaim");
  }

  availableActions.push("duplicateOrder");
  availableActions.push("refundOrder");

  if (canViewAllOrders) {
    availableActions.push("viewInRedo");
  }

  return availableActions;
}
